import React from 'react';
import PropTypes from 'prop-types';
import { range, isNumber } from 'lodash-es';
import { Skeleton } from '@chakra-ui/react';

const DEFAULT_ROWS = 6;
const DEFAULT_MOBILE_ROWS = 3;
const DEFAULT_MOBILE_WIDTH = 40;

const computedMobileWidth = (width = DEFAULT_MOBILE_WIDTH) =>
  isNumber(width) ? `${width}%` : width;

const ListSkeleton = ({ coloums, skeleton = {} }) => {
  const {
    rows = DEFAULT_ROWS,
    mobileRows = DEFAULT_MOBILE_ROWS,
    mobileSizes = [],
  } = skeleton;

  return (
    <div className="member-center__list">
      <div className="member-center__list-mobile">
        {range(mobileRows).map((index) => {
          return (
            <div className="member-center__list-mobile-item" key={index}>
              {mobileSizes.map((option, optionIndex) => {
                return (
                  <div
                    key={`option?.[0]-${optionIndex}`}
                    className="member-center__list-mobile-item-option"
                  >
                    {option?.[0] && (
                      <Skeleton
                        width={computedMobileWidth(option?.[0])}
                        height="20px"
                      />
                    )}
                    {option?.[1] && (
                      <Skeleton
                        width={computedMobileWidth(option?.[1])}
                        height="20px"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <table>
        <tbody>
          {range(rows).map((index) => {
            return (
              <tr key={index}>
                {coloums.map((coloumItem) => {
                  if (Array.isArray(coloumItem)) {
                    return null;
                  }
                  const { id, key } = coloumItem;
                  return (
                    <td key={key || id}>
                      <Skeleton height="20px" mr="65px" />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

ListSkeleton.propTypes = {
  skeleton: PropTypes.exact({
    rows: PropTypes.number,
    mobileRows: PropTypes.number,
    mobileSizes: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      ),
    ),
  }),
  coloums: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ]),
  ),
};

export default ListSkeleton;
